export default () => {

  const buttons = document.querySelectorAll(".accord__btn");
  const accordItems = document.querySelectorAll(".accord__item");

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", function (e) {

      for (let i = 0; i < accordItems.length; i++) {
        if (e.target.parentElement === accordItems[i]) {
          continue;
        }
        accordItems[i].classList.remove("active");
      }

      if (document.documentElement.clientWidth < 640) {
        this.parentElement.classList.toggle("active");
      } else if (!this.parentElement.classList.contains("active")) {
        this.parentElement.classList.add("active");
      }
    })
  }

  // додаємо активний клас для першого компоненту складу на розширенні >= 640, щоб не було пустого місця в блоці з описом
  function addActive() {
    const itemActivePrev = document.querySelector(".accord__item.active");

    function removeActive(items) {
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove("active");
      }
    }

    if (document.documentElement.clientWidth >= 640) {
      if (document.querySelector(".accord__item.active")) {
        removeActive(accordItems);
        itemActivePrev.classList.add("active")
      } else {
        removeActive(accordItems);
        accordItems[0].classList.add("active")
      }
    }
  }

  window.addEventListener("resize", addActive);
};
